// extracted by mini-css-extract-plugin
module.exports = {"accentColor":"#a5beb3","darkTextColor":"yellow","darkBackgroundColor":"#000000"};